<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-4.jpg)' }"
  class="content-header"
  id="grad"
>
  <span class="header-title">Spike Bases</span>
</div>
<app-form
  class="new-base-form"
  [sections]="sections"
  [data]="base"
  [mode]="mode"
  cancel="bases"
  (submitted)="submitForm($event)"
></app-form>
